module.exports = __webpack_public_path__ + "static/img/11.2377707.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/11.png
// module id = caMo
// module chunks = 0